import { getDeviceId } from "@/utils/frontend/device";

type ApiErrorPayload = { error?: string };

export class InternalAdminApiError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message);
  }
}

export async function postInternalAdminRequest<TResponse>(
  url: string,
  authData: unknown,
  body: Record<string, unknown>
): Promise<TResponse> {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...body, authData, deviceId: getDeviceId() }),
  });
  const payload = (await response.json().catch(() => ({}))) as TResponse & ApiErrorPayload;

  if (!response.ok) {
    throw new InternalAdminApiError(payload.error ?? "Request failed", response.status);
  }
  return payload;
}
